import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate, random } from "remotion";
import React from "react";

// VFX: Watercolor Ink Reveal
// Category: overlays · Tags: ink, watercolor, reveal, organic, title
export default function FxWatercolorInkReveal1200Ms() {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 30, stiffness: 50 } });
  const cx = width / 2;
  const cy = height / 2;
  const baseR = interpolate(p, [0, 1], [0, Math.max(width, height) * 0.55]);

  const blobs = Array.from({ length: 8 }, (_, i) => {
    const angle = (i / 8) * Math.PI * 2;
    const wobble = Math.sin(frame * 0.04 + i) * 0.15;
    const r = baseR * (0.75 + 0.4 * random(`r-${i}`) + wobble);
    const offset = baseR * 0.35;
    return {
      cx: cx + Math.cos(angle) * offset * random(`o-${i}`),
      cy: cy + Math.sin(angle) * offset * random(`oo-${i}`),
      r,
      hue: 220 + random(`h-${i}`) * 80,
      alpha: 0.18 + random(`a-${i}`) * 0.18,
    };
  });

  const textOp = interpolate(p, [0.5, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: "#fef3c7" }}>
      <svg width="100%" height="100%" style={{ position: "absolute", inset: 0 }}>
        <defs>
          <filter id="wcBlur">
            <feGaussianBlur stdDeviation="14" />
          </filter>
        </defs>
        <g filter="url(#wcBlur)">
          {blobs.map((b, i) => (
            <circle key={i} cx={b.cx} cy={b.cy} r={b.r}
              fill={`hsl(${b.hue}, 70%, 55%)`}
              opacity={b.alpha}
              style={{ mixBlendMode: "multiply" } as React.CSSProperties} />
          ))}
        </g>
      </svg>
      <AbsoluteFill style={{ alignItems: "center", justifyContent: "center" }}>
        <span style={{
          fontSize: 132, fontWeight: 900,
          color: "#0a0e1a",
          fontFamily: "Georgia, serif",
          opacity: textOp,
          letterSpacing: "-0.03em"
        }}>BLOOM</span>
      </AbsoluteFill>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
